export default __webpack_public_path__ + "img/AcgDfAAH.a9d4ce04.svg";